import { Logger } from '@aws-lambda-powertools/logger'

export function assertNever(input: never, logger?: Logger): null {
  if (logger) {
    logger.error('Unexpected function call with input', { input })
  } else {
    console.error('Unexpected function call with input', { input: stringifyObject(input) })
  }

  return null
}

const stringifyObject = (input: unknown) => {
  if (typeof input !== 'object') return input

  try {
    return JSON.stringify(input)
  } finally {
    return input
  }
}
